import { useQuery } from '@tanstack/react-query';
import API from '../API';

export const useGetNavigationConfig = () => {
  const { data, isError, isLoading } = useQuery(['_getNavigationConfig'], () =>
    API.get('/project-panel/auth/generate-staff-user-navigation-config')
  );
  return {
    data: data?.data?.data || {},
    isLoading,
    isError,
  };
};
